
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSensorWaterCo2 as ObiSensorWaterCo2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-sensor-water-co2.js';
 
 
 

 
 export const ObiSensorWaterCo2 = createComponent({
   react: React,
   tagName: 'obi-sensor-water-co2',
   elementClass: ObiSensorWaterCo2Element,
   events: {
     
   }
  });
 
 